export enum InvitationLogEntryParamKey {
  InvitationTitle = 'INVITATION_TITLE',
  ResponsiblePersonOldId = 'RESPONSIBLE_PERSON_OLD_ID',
  ResponsiblePersonOldName = 'RESPONSIBLE_PERSON_OLD_NAME',
  ResponsiblePersonNewId = 'RESPONSIBLE_PERSON_NEW_ID',
  ResponsiblePersonNewName = 'RESPONSIBLE_PERSON_NEW_NAME',
  ResponsiblePersonConfirmedId = 'RESPONSIBLE_PERSON_CONFIRMED_ID',
  ResponsiblePersonConfirmedName = 'RESPONSIBLE_PERSON_CONFIRMED_NAME',
  PersonId = 'PERSON_ID',
  PersonName = 'PERSON_NAME',
  PersonOldId = 'PERSON_OLD_ID',
  PersonOldName = 'PERSON_OLD_NAME',
  PersonEmployeeId = 'PERSON_EMPLOYEE_ID',
  CertificateId = 'CERTIFICATE_ID',
  CertificateName = 'CERTIFICATE_NAME',
  CertificateValidTo = 'CERTIFICATE_VALID_TO',
  WorkplaceName = 'WORKPLACE_NAME',
  WorkplaceId = 'WORKPLACE_ID',
  RiskId = 'RISK_ID',
  RiskName = 'RISK_NAME',
  RiskVersionValidFrom = 'RISK_VERSION_VALID_FROM',
  ActivityName = 'ACTIVITY_NAME',
  ActivityId = 'ACTIVITY_ID',
  EntryRequestId = 'ENTRY_REQUEST_ID',
  EntryRequestRejectReason = 'ENTRY_REQUEST_REJECT_REASON',
  ArchiveAfterDays = 'ARCHIVE_AFTER_DAYS',
  DocumentId = 'DOCUMENT_ID',
  DocumentName = 'DOCUMENT_NAME',
}
